module.exports = __webpack_public_path__ + "img/gift_25.a5591527.webp";